import { render, staticRenderFns } from "./MineHome.vue?vue&type=template&id=5731365e"
import script from "./MineHome.vue?vue&type=script&lang=js"
export * from "./MineHome.vue?vue&type=script&lang=js"
import style0 from "./MineHome.vue?vue&type=style&index=0&id=5731365e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports